import { Typography as MuiTypography } from '@mui/material';

/**
 * Typography — text element with semantic variants (h1..h6, body1,
 * body2, caption, subtitle1, subtitle2). Thin MUI wrapper; design
 * tokens for each variant come from the theme at @shared/config/theme.
 */
const Typography = (props) => <MuiTypography {...props} />;

export default Typography;
